var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1Contact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 61,
    viewBox: "0 0 57 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36133 56.2852L6.21696 48.3333C6.57626 46.8967 6.86031 45.4423 7.06797 43.9761C7.2263 42.7161 7.69861 41.5162 8.44152 40.4863C9.18444 39.4565 10.1742 38.6298 11.3198 38.0821L20.3801 33.9224C21.0907 33.5961 21.7212 33.118 22.2272 32.5219C22.7332 31.9257 23.1024 31.2259 23.3089 30.4718L23.8173 28.6151",
    stroke: "#A2F4A2",
    strokeWidth: 0.535227,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2314 56.2852L51.394 48.4109C51.0455 46.9177 50.7212 45.4169 50.5146 43.8974C50.3448 42.6525 49.8683 41.4693 49.1279 40.4542C48.3875 39.4392 47.4065 38.624 46.2729 38.0821L37.2126 33.9224C36.502 33.5961 35.8715 33.118 35.3656 32.5219C34.8596 31.9257 34.4903 31.2259 34.2839 30.4718L33.7754 28.6151",
    stroke: "#A2F4A2",
    strokeWidth: 0.535227,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36133 56.2852L6.21696 48.3333C6.57626 46.8967 6.86031 45.4423 7.06797 43.9761C7.2263 42.7161 7.69861 41.5162 8.44152 40.4863C9.18444 39.4565 10.1742 38.6298 11.3198 38.0821L20.3801 33.9224C21.0907 33.5961 21.7212 33.118 22.2272 32.5219C22.7332 31.9257 23.1024 31.2259 23.3089 30.4718L23.8173 28.6151",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2314 56.2852L51.394 48.4109C51.0455 46.9177 50.7212 45.4169 50.5146 43.8974C50.3448 42.6525 49.8683 41.4693 49.1279 40.4542C48.3875 39.4392 47.4065 38.624 46.2729 38.0821L37.2126 33.9224C36.502 33.5961 35.8715 33.118 35.3656 32.5219C34.8596 31.9257 34.4903 31.2259 34.2839 30.4718L33.7754 28.6151",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4159 12.7635V20.786C37.4159 25.8985 33.5569 30.0454 28.7988 30.0454C24.0406 30.0454 20.1816 25.9006 20.1816 20.786V15.2384",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8418 35.1483V56.8196",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7734 35.1483V56.8196",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7043 33.5993C14.8788 33.3058 14.1304 32.8295 13.5149 32.206C12.8995 31.5824 12.4331 30.8278 12.1505 29.9985C11.8679 29.1692 11.7764 28.2868 11.883 27.4171C11.9896 26.5475 12.2914 25.7133 12.7659 24.9768V24.9661C12.7758 24.9598 12.7833 24.9504 12.7873 24.9393C12.9807 24.6462 13.1991 24.3704 13.4403 24.1151C15.9184 20.8449 16.3198 18.142 16.0683 14.0742C16.0683 14.0154 16.0629 13.9511 16.0576 13.8923C16.0585 13.8618 16.0567 13.8314 16.0522 13.8013H16.057C16.0517 13.6354 16.041 13.4641 16.041 13.2982C16.041 11.6218 16.3712 9.9619 17.0127 8.41316C17.6542 6.86442 18.5944 5.4572 19.7798 4.27185C20.9652 3.08649 22.3724 2.14622 23.9211 1.50471C25.4699 0.8632 27.1298 0.53302 28.8061 0.53302C30.4825 0.53302 32.1424 0.8632 33.6911 1.50471C35.2399 2.14622 36.6471 3.08649 37.8324 4.27185C39.0178 5.4572 39.9581 6.86442 40.5996 8.41316C41.2411 9.9619 41.5713 11.6218 41.5713 13.2982C41.5713 13.4641 41.5659 13.6354 41.5552 13.8013H41.5606C41.5606 13.8334 41.5552 13.8602 41.5552 13.8923C41.5552 13.9511 41.5499 14.0154 41.5445 14.0742C41.293 18.142 41.6997 20.8449 44.1725 24.1151C44.4136 24.3704 44.6321 24.6462 44.8255 24.9393C44.8312 24.9493 44.8384 24.9583 44.8469 24.9661V24.9768C45.3206 25.7121 45.6222 26.5449 45.7292 27.413C45.8362 28.2811 45.7459 29.1622 45.465 29.9905C45.1841 30.8189 44.7198 31.5731 44.1068 32.1971C43.4937 32.821 42.7478 33.2985 41.9245 33.594C41.9192 33.594 41.9192 33.594 41.9138 33.5993",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 13.2478C30.2688 13.2478 35.3246 4.48185 35.3246 2.33185",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6133 8.88849C35.0584 12.1534 38.0557 13.2704 41.5635 13.2704",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8398 39.1229C22.1096 39.8654 25.4527 40.237 28.8058 40.2308C31.3036 40.233 33.7973 40.0286 36.2615 39.6196C37.1132 39.4768 37.9499 39.3113 38.7717 39.1229",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7184 60.3577L45.1528 46.1421C45.2252 45.8286 45.226 45.5028 45.1551 45.1889C45.0843 44.8751 44.9436 44.5812 44.7435 44.3292C44.5435 44.0772 44.2892 43.8736 43.9996 43.7334C43.71 43.5932 43.3925 43.5201 43.0707 43.5195H14.5485C14.2263 43.5193 13.9082 43.5918 13.618 43.7316C13.3277 43.8715 13.0727 44.075 12.8721 44.3271C12.6714 44.5792 12.5302 44.8734 12.4591 45.1876C12.3879 45.5019 12.3886 45.8281 12.4611 46.1421L13.8956 60.3577",
    fill: "#D2ECFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7184 60.3577L45.1528 46.1421C45.2252 45.8286 45.226 45.5028 45.1551 45.1889C45.0843 44.8751 44.9436 44.5812 44.7435 44.3292C44.5435 44.0772 44.2892 43.8736 43.9996 43.7334C43.71 43.5932 43.3925 43.5201 43.0708 43.5195H14.5485C14.2263 43.5193 13.9082 43.5918 13.618 43.7316C13.3277 43.8715 13.0727 44.075 12.8721 44.3271C12.6714 44.5792 12.5302 44.8734 12.4591 45.1876C12.3879 45.5019 12.3886 45.8281 12.4611 46.1421L13.8956 60.3577",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0797 60.3592H0.535156",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5429 51.9398C30.543 51.5963 30.4412 51.2605 30.2505 50.9749C30.0597 50.6893 29.7886 50.4667 29.4713 50.3352C29.154 50.2037 28.8048 50.1693 28.468 50.2363C28.1311 50.3033 27.8217 50.4686 27.5789 50.7115C27.336 50.9543 27.1706 51.2638 27.1036 51.6006C27.0367 51.9375 27.0711 52.2866 27.2026 52.6039C27.3341 52.9212 27.5567 53.1924 27.8423 53.3831C28.1279 53.5738 28.4637 53.6756 28.8071 53.6755C29.0351 53.6755 29.2608 53.6306 29.4714 53.5434C29.682 53.4561 29.8733 53.3283 30.0345 53.1671C30.1957 53.0059 30.3235 52.8146 30.4107 52.604C30.498 52.3934 30.5429 52.1677 30.5429 51.9398Z",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4772 25.8006H29.476C29.2864 25.8043 29.0979 25.7701 28.9215 25.7001C28.7452 25.63 28.5847 25.5255 28.4492 25.3927C28.3138 25.2599 28.2062 25.1013 28.1328 24.9264C28.0593 24.7515 28.0215 24.5637 28.0215 24.374C28.0215 24.1843 28.0593 23.9965 28.1328 23.8216C28.2062 23.6466 28.3138 23.4881 28.4492 23.3553C28.5847 23.2225 28.7452 23.118 28.9215 23.0479C29.0979 22.9779 29.2864 22.9437 29.476 22.9474H31.4772C31.8508 22.9546 32.2067 23.1081 32.4683 23.3748C32.73 23.6416 32.8765 24.0003 32.8765 24.374C32.8765 24.7477 32.73 25.1064 32.4683 25.3732C32.2067 25.6399 31.8508 25.7934 31.4772 25.8006Z",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3959 19.1776C36.7965 22.1497 34.8413 24.3741 32.9043 24.3741",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1Contact);
export default __webpack_public_path__ + "static/media/icon1contact.dc01667f31c004f304f125255a342269.svg";
export { ForwardRef as ReactComponent };